import React from 'react';
import { InsightSelectFormikWrapper } from '@/components/forms/CreateClientForm/Fields/InsightSelectFormikWrapper';
import OptionSelectField from '@/components/forms/CreateClientForm/Fields/OptionSelectField';
import ClientSelectField from '@/components/forms/CreateClientForm/Fields/ClientSelectField';
import FormikDateField from '@/components/forms/CreateClientForm/Fields/FormikDateField';
import FormikTextField from '@/components/forms/CreateClientForm/Fields/FormikTextField';
import UserCreationInfoField from '@/components/forms/CreateClientForm/Fields/CreationInfoFields/UserCreationInfoField';
import BrokerageCreationInfoField from '@/components/forms/CreateClientForm/Fields/CreationInfoFields/BrokerageCreationInfoField';
import AuthRepSelect from '@/components/forms/CreateClientForm/Fields/AuthRepSelect';
import ReferralPartnerFormikField from '@/components/forms/CreateClientForm/Fields/ReferralPartnerFormikField';
import InsightProxySelect from '@/components/forms/CreateClientForm/Fields/InsightProxySelect';

const ClientFormField = ({ field, disabled }) => {
	const [entity, type] = (field.field?.default ?? '').split('.');

	if (field.name.includes('AuthorisedRep')) {
		return <AuthRepSelect {...{ field, disabled }} />;
	}

	if (field.name === 'RecordPermissionsGroupId') {
		return (
			<InsightProxySelect
				{...{ field, disabled }}
				fieldType='PermissionsGroup'
				disableOnUpdate
			/>
		);
	}

	switch (field.name) {
		case 'Category1Id':
		case 'Category2Id':
		case 'Category3Id':
		case 'Category4Id':
		case 'Category5Id':
			return <InsightSelectFormikWrapper {...{ field, disabled }} />;
		case 'LegalEntityTypeId':
			return <OptionSelectField {...{ field, disabled }} />;
		case 'AccountTypeId':
			return (
				<InsightProxySelect
					{...{ field, disabled }}
					fieldType='AccountType'
					clearable
				/>
			);
		case 'UsualDebtorId':
			return <ClientSelectField {...{ field, disabled }} filterProspects={true} />;
		case 'referralPartner':
			return <ReferralPartnerFormikField {...{ field, disabled }} />;
		default: {
			// "BranchId":
			// "CountryId":
			// "ownerId":
			// "SalesTeamId":
			// "ServiceTeamId":
			if (['brokerGroup', 'user'].includes(entity)) {
				return entity === 'user' ? (
					<UserCreationInfoField {...{ field, type, disabled }} />
				) : (
					<BrokerageCreationInfoField {...{ field, type, disabled }} />
				);
			}
			switch (field.field?.fieldType) {
				case 'select':
				case 'radio':
					return field.field?.endpoint ? (
						<InsightSelectFormikWrapper {...{ field, disabled }} />
					) : field.field?.options ? (
						<OptionSelectField {...{ field, disabled }} />
					) : (
						<FormikTextField {...{ field, disabled }} />
					);
				case 'date':
					return <FormikDateField {...{ field, disabled }} />;
				default:
					return <FormikTextField {...{ field, disabled }} />;
			}
		}
	}
};

export default ClientFormField;
